import { IErrorResponseType, IInstitutionListResponse, ISuccessResponseType } from "../../constants/commonTypes"


export const GET_INSTITUTION_LIST = "GET_INSTITUTION_LIST"
export const GET_INSTITUTION_LIST_REQUEST = "GET_INSTITUTION_LIST_REQUEST"
export const GET_INSTITUTION_LIST_SUCCESS = "GET_INSTITUTION_LIST_SUCCESS"
export const GET_INSTITUTION_LIST_FAILURE = "GET_INSTITUTION_LIST_FAILURE"

export const INITIATE_UPLOAD_DOC = "INITIATE_UPLOAD_DOC"
export const INITIATE_UPLOAD_DOC_REQUEST = "INITIATE_UPLOAD_DOC_REQUEST"
export const INITIATE_UPLOAD_DOC_SUCCESS = "INITIATE_UPLOAD_DOC_SUCCESS"
export const INITIATE_UPLOAD_DOC_FAILURE = "INITIATE_UPLOAD_DOC_FAILURE"

export const UPLOAD_DOCUMENTS = "UPLOAD_DOCUMENTS"
export const UPLOAD_DOCUMENTS_REQUEST = "UPLOAD_DOCUMENTS_REQUEST"
export const UPLOAD_DOCUMENTS_SUCCESS = "UPLOAD_DOCUMENTS_SUCCESS"
export const UPLOAD_DOCUMENTS_FAILURE = "UPLOAD_DOCUMENTS_FAILURE"

export const UPLOAD_DOCUMENTS_RESET = "UPLOAD_DOCUMENTS_RESET"

export const UPLOAD_DETAILS = "UPLOAD_DETAILS"
export const UPLOAD_DETAILS_REQUEST = "UPLOAD_DETAILS_REQUEST"
export const UPLOAD_DETAILS_SUCCESS = "UPLOAD_DETAILS_SUCCESS"
export const UPLOAD_DETAILS_FAILURE = "UPLOAD_DETAILS_FAILURE"

export const RESUME_JOURNEY = "RESUME_JOURNEY"
export const RESUME_JOURNEY_REQUEST = "RESUME_JOURNEY_REQUEST"
export const RESUME_JOURNEY_SUCCESS = "RESUME_JOURNEY_SUCCESS"
export const RESUME_JOURNEY_FAILURE = "RESUME_JOURNEY_FAILURE"


// Get Transaction Details
export interface GetInstitutionListAction {
  type: typeof GET_INSTITUTION_LIST;
  query: string;
}

export interface GetInstitutionListRequestAction {
  type: typeof GET_INSTITUTION_LIST_REQUEST;
}

export interface GetInstitutionListSuccessAction {
  type: typeof GET_INSTITUTION_LIST_SUCCESS;
  institutionList: Array<IInstitutionListResponse>;
}

export interface GetInstitutionListFailureAction {
  type: typeof GET_INSTITUTION_LIST_FAILURE;
  error: Error | string | null | IErrorResponseType;
}


// Get Transaction Details
export interface InititateUploadDocAction {
  type: typeof INITIATE_UPLOAD_DOC;
  request: object;
}

export interface InititateUploadDocRequestAction {
  type: typeof INITIATE_UPLOAD_DOC_REQUEST;
}

export interface InititateUploadDocSuccessAction {
  type: typeof INITIATE_UPLOAD_DOC_SUCCESS;
  initiateResponse: string;
}

export interface InititateUploadDocFailureAction {
  type: typeof INITIATE_UPLOAD_DOC_FAILURE;
  error: Error | string | null | IErrorResponseType;
}


// Upload Documents
export interface UploadDocumentsAction {
  type: typeof UPLOAD_DOCUMENTS;
  perfTxnId: string;
  documents: FormData;
}

export interface UploadDocumentsRequstAction {
  type: typeof UPLOAD_DOCUMENTS_REQUEST;
}

export interface UploadDocumentSuccessAction {
  type: typeof UPLOAD_DOCUMENTS_SUCCESS;
  uploadDocumentResponse: Array<ISuccessResponseType>
}

export interface UploadDocumentFailureAction {
  type: typeof UPLOAD_DOCUMENTS_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export interface UploadDocumentResetAction {
  type: typeof UPLOAD_DOCUMENTS_RESET
}


// Upload Details  (Callled when the In-App Back is pressed)
export interface UploadDetailsAction {
  type: typeof UPLOAD_DETAILS;
  request: object;
}

export interface UploadDetailsRequstAction {
  type: typeof UPLOAD_DETAILS_REQUEST;
}

export interface UploadDetailsSuccessAction {
  type: typeof UPLOAD_DETAILS_SUCCESS;
  institutionName: string;
  fileList: Array<string>;
  passwordFlag: boolean;
}

export interface UploadDetailsFailureAction {
  type: typeof UPLOAD_DETAILS_FAILURE;
  error: Error | string | null | IErrorResponseType;
}


// Resume Journey  (Callled in thank-you page)
export interface ResumeJourneyAction {
  type: typeof RESUME_JOURNEY;
}

export interface ResumeJourneyRequstAction {
  type: typeof RESUME_JOURNEY_REQUEST;
}

export interface ResumeJourneySuccessAction {
  type: typeof RESUME_JOURNEY_SUCCESS;
  resumeJourneyResponse: boolean;
}

export interface ResumeJourneyFailureAction {
  type: typeof RESUME_JOURNEY_FAILURE;
  error: Error | string | null | IErrorResponseType;
}

export type UploadDocumentActions =
  | GetInstitutionListAction
  | GetInstitutionListRequestAction
  | GetInstitutionListSuccessAction
  | GetInstitutionListFailureAction

  | InititateUploadDocAction
  | InititateUploadDocRequestAction
  | InititateUploadDocSuccessAction
  | InititateUploadDocFailureAction

  | UploadDocumentsAction
  | UploadDocumentsRequstAction
  | UploadDocumentSuccessAction
  | UploadDocumentFailureAction

  | UploadDocumentResetAction

  | UploadDetailsAction
  | UploadDetailsRequstAction
  | UploadDetailsSuccessAction
  | UploadDetailsFailureAction

  | ResumeJourneyAction
  | ResumeJourneyRequstAction
  | ResumeJourneySuccessAction
  | ResumeJourneyFailureAction;